import App from './App';
import React from 'react';
import getFirebaseConfig from './firebase/config';
import { initializeCustomData } from './utils/customData';
import { initializeApp } from '@firebase/app';
import { createRoot } from 'react-dom/client';
import {
  CartProvider,
  ThemeProvider,
  GlobalProvider,
  APICacheProvider,
  CookieConsentProvider,
  SuccessDrawerProvider,
} from './context';
import 'simplebar-react/dist/simplebar.min.css';
import 'assets/main.css';
import 'focus-visible';
import './i18n';

if (!window.dataLayer) window.dataLayer = [];
window.dataLayer.push({
  event: 'default_consent',
  consent: {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  },
});

const firebaseConfig = getFirebaseConfig();

initializeApp(firebaseConfig);
initializeCustomData();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <APICacheProvider>
      <ThemeProvider>
        <CookieConsentProvider>
          <GlobalProvider>
            <CartProvider>
              <SuccessDrawerProvider>
                <App />
              </SuccessDrawerProvider>
            </CartProvider>
          </GlobalProvider>
        </CookieConsentProvider>
      </ThemeProvider>
    </APICacheProvider>
  </React.StrictMode>
);
